import { useTheme } from 'next-themes'

interface LogoProps {
  variant?: 'default' | 'header' | 'footer' | 'sidebar' | 'rail'
  className?: string
}

export function Logo({ variant = 'default', className = '' }: LogoProps) {
  // The app is light-only (forcedTheme in App.tsx), and next-themes' resolvedTheme
  // ignores the forced theme: a dark OS got the white logo on a light page,
  // with half of it gone.
  const { forcedTheme, resolvedTheme } = useTheme()
  const theme = forcedTheme ?? resolvedTheme

  // The artwork is 99 x 50. The header box is wider than the drawn logo, which
  // sits centred in it; the sidebar's boxes fit the artwork, so the logo lines
  // up with the menu under it. The rail's is the favicon's size of the logo.
  const sizeMap = {
    default: { height: '36px', width: '130px' },     // h-9
    header: { height: '32px', width: '115px' },      // h-8
    footer: { height: '24px', width: '87px' },       // h-6
    sidebar: { height: '32px', width: '64px' },      // the header's logo, without the empty sides
    rail: { height: '20px', width: '40px' },         // the sidebar folded to its icons
  }

  const size = sizeMap[variant]
  const logoSrc = theme === 'dark' ? '/x11-white.png' : '/X11.Social.svg?v=2'

  return (
    <div
      className={className}
      style={{
        width: size.width,
        height: size.height,
        backgroundImage: `url('${logoSrc}')`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      }}
      role="img"
      aria-label="X11.Social"
    />
  )
}